import {useCallback, useEffect, useMemo, useState} from 'react'

type ErrorState = ErrorEvent | null;

export const useScriptElement = (src: HTMLScriptElement['src']): [boolean, ErrorState] => {
  const isBrowser = useMemo(() =>
    typeof window !== 'undefined' && typeof window.document !== 'undefined',
    [window],
  )

  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<ErrorState>(null)

  const handleLoad = useCallback((): void => {
    setLoading(false)
  }, [])
  const handleError = useCallback((error: ErrorEvent): void => {
    setError(error)
  }, [])

  useEffect(() => {
    if (!isBrowser || !src || !loading || error) {
      return
    }

    const scriptEl = document.createElement('script')
    scriptEl.src = src

    scriptEl.addEventListener('load', handleLoad)
    scriptEl.addEventListener('error', handleError)

    document.body.appendChild(scriptEl)

    return () => {
      scriptEl.removeEventListener('load', handleLoad)
      scriptEl.removeEventListener('error', handleError)
    }
  }, [src])

  return [loading, error]
}
